import React, { useMemo } from 'react';
import { KitContext, KitContextProps, kitSlice } from '../context/KitContext';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { Kit } from '../types/kit/kit';

interface KitProviderProps {
  children: React.ReactNode;
}

export default function KitProvider({ children }: KitProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.kits.items);
  const loading = useAppSelector(state => state.kits.loading);

  const kits = useMemo(() => {
    return new Map(items.map(item => [item.id, new Kit(item)]));
  }, [items]);

  const kitContext: KitContextProps = {
    kits,
    kitsLoading: loading,
    setKits: (kits: Map<string, Kit>) => dispatch(kitSlice.actions.set([...kits.values()])),
  };

  return <KitContext.Provider value={kitContext}>{children}</KitContext.Provider>;
}
